import { createElement } from 'react';
import { cx } from 'linaria';
import { classNames as classNames$2 } from '@uds/typography';
import './label.stylesheet_q67vpp.css';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import './labeloption.stylesheet_1928hgg.css';

const label$1 = "label_l91n8dm";
const hint$1 = "label_hsorl3t";
const classNames$1 = {
  label: cx(label$1, classNames$2.footnote),
  hint: hint$1
};

const Label = _ref => {
  let {
    children,
    htmlFor,
    as = 'label',
    hint,
    disabled,
    readOnly,
    block = true,
    classes = classNames$1,
    ...domProps
  } = _ref;
  return /*#__PURE__*/createElement(as, {
    'data-disabled': disabled,
    'data-readonly': readOnly,
    'data-display': block ? 'block' : undefined,
    'className': classes.label,
    htmlFor,
    ...domProps
  }, /*#__PURE__*/jsxs(Fragment, {
    children: [children, hint != null && /*#__PURE__*/jsx("span", {
      className: classes.hint,
      children: hint
    })]
  }));
};
var Label$1 = Label;

const label = "label_ljobw9d";
const hint = "label_hv1d56q";
const classNames = {
  label: cx(label, classNames$2.headingXxs),
  hint: cx(hint, classNames$2.content)
};

const LabelOption = props => {
  return /*#__PURE__*/jsx(Label$1, {
    ...props,
    classes: classNames
  });
};
var LabelOption$1 = LabelOption;

export { Label$1 as Label, LabelOption$1 as LabelOption, Label$1 as default };
